import React from 'react';
import { Box, Typography } from '@mui/material';
import ManageLocation from './ManageLocation';

/**
 * Locations Page - Standalone route for location management
 * Previously a tab in the Admin component
 */
export default function LocationsPage() {
  return (
    <Box sx={{ width: '100%', p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3, fontWeight: 600 }}>
        Location Management
      </Typography>
      <ManageLocation />
    </Box>
  );
}
